module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_uppsala-df56747f07070664b3bc238e9efb3b2e.png";